import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import { WindowWidthContext } from '@minecraft.utils';
import { DrawerProps } from '../shared/types';
import { useDrawerToggleCategory, useDrawerSearchFilterNameOrCategory, useDrawerGlobalLoader } from '../shared/hooks';
import {
  DrawerCategoryViewContainer,
  DrawerCategoryViewEmpty,
  DrawerCategoryViewHeader,
  DrawerCategoryViewBody,
  DrawerCategoryViewTitle,
  LoaderContainer,
  Loader,
} from './DrawerCategoryViewStyles';

interface Props {
  children: DrawerProps['children'];
}

const DrawerCategoryView: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const { lessSm } = WindowWidthContext.useWidthData();

  const { activeCategory } = useDrawerToggleCategory();
  const { isSearching, noSearchResult } = useDrawerSearchFilterNameOrCategory();
  const { isLoading } = useDrawerGlobalLoader();

  const isDrawerCategoryViewVisible = !lessSm || activeCategory.value || (isSearching && noSearchResult);

  return (
    isDrawerCategoryViewVisible && (
      <DrawerCategoryViewContainer data-testid="drawer-filters-wrapper" $isLoading={isLoading}>
        {isLoading && (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        )}
        {(activeCategory.value || isSearching) && !noSearchResult && (
          <>
            {!isSearching && (
              <DrawerCategoryViewHeader>
                <DrawerCategoryViewTitle data-testid={`category-view-${activeCategory.label}`}>
                  {activeCategory.label}
                </DrawerCategoryViewTitle>
              </DrawerCategoryViewHeader>
            )}
            <DrawerCategoryViewBody $isSearching={isSearching}>{children}</DrawerCategoryViewBody>
          </>
        )}
        {!(activeCategory.value || isSearching) && !noSearchResult && (
          <DrawerCategoryViewEmpty data-testid="drawer-category-view-empty">
            {t('common:filter.searchFilterOrCategory')}
          </DrawerCategoryViewEmpty>
        )}
        {isSearching && noSearchResult && (
          <DrawerCategoryViewEmpty data-testid="drawer-category-view-empty">
            {t('common:filter.noResults')}
          </DrawerCategoryViewEmpty>
        )}
      </DrawerCategoryViewContainer>
    )
  );
};

export default DrawerCategoryView;
